
export const COLOR = {
    lightGreen: "#CBFEA0",
    neonGreen: "#00FF00",
    grassGreen: "#77af26",
    addictionRoadGreen: "#738d43",
    green: "#4B9401",
    backgroundGreen: "#99CC33",
    blue: "#027abb",
    yellow: "#f4ffba",
    brightYellow: "#ffff00",
    orange: "#FF8800",
    redOrange: "#f59e42",
    red: "#cc0000",
    black: "#000000",
    white: "#ffffff",
    lightGray: "#eeeeee",
    gray: "#999999",
    darkGray: "#444444",
    defaultButton: "#27ACA0",

    // Mui colors
    primaryLight: "#33ab9f",
    primary: "#009688",
    primaryDark: "#00695f",
    secondaryLight: "#ffee33",
    secondary: "#ffea00",
    secondaryDark: "#b2a300",
}

